import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    height: theme.spacing(2.5),
    fontSize: 10,
    letterSpacing: 1,
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.lighter,
    borderColor: fade(theme.palette.primary.main, 0.2),
    textTransform: 'uppercase',
  },
  isValid: {
    backgroundColor: fade(theme.palette.success.main, 0.3),
    borderColor: theme.palette.success.main,
    color: theme.palette.primary.main,
  },
  isAttached: {
    backgroundColor: theme.palette.primary.lighter,
    borderColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  isPending: {
    backgroundColor: theme.palette.grey[100],
    borderColor: theme.palette.grey[200],
    color: theme.palette.grey[400],
  },
  isExpired: {
    backgroundColor: theme.palette.secondary.lighter,
    borderColor: theme.palette.secondary.dark,
    color: theme.palette.primary.main,
  },
  isRejected: {
    backgroundColor: theme.palette.error.light,
    borderColor: theme.palette.error.main,
    color: theme.palette.primary.main,
  },
  deletable: {
    margin: theme.spacing(0, 2, 2, 0),
    color: theme.palette.primary.light,
    fontSize: 12,
    letterSpacing: 0,
    textTransform: 'none',
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
    '&:focus.MuiChip-deletable': {
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  closeButton: {
    color: theme.palette.primary.light,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

export default useStyles
